import React from "react";

export const SuspenceFallbackContainer = () => {
    return <div className="loading animate__animated  animate__fadeIn"></div>;
};
